import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {BookingComponent} from "./booking.component";
import {BookingDetailComponent} from "./detail/booking-detail.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/company/:id/booking', {template: ''})
            .when('/company/:companyId/booking/:id', {template: ''})
            .when('/booking', {template: ''});
    }]);
/***/

const bookingRoutes: Routes = [
    {path: 'booking', component: BookingComponent},
    {path: 'booking/:id', component: BookingDetailComponent},
    {path: 'company/:companyId/booking', component: BookingComponent},
    {path: 'cars-sara-v2/web/company/:companyId/booking', component: BookingComponent},
    {path: 'company/:companyId/booking/:id', component: BookingDetailComponent},
    {path: 'cars-sara-v2/web/company/:companyId/booking/:id', component: BookingDetailComponent},
    {path: 'cars-sara-v2/web/booking', component: BookingComponent},
    {path: 'cars-sara-v2/web/booking/:id', component: BookingDetailComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(bookingRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class BookingRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/booking/booking-routing.module.ts